var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInfoItalic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1-1h20v20H-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 .667A8.333 8.333 0 11.667 9C.667 4.417 4.392.667 9 .667zm.83 5.978c-.868.073-3.238 1.961-3.238 1.961-.145.11-.102.103.015.307.117.197.102.211.24.116.146-.094.387-.248.788-.495 1.546-.992.248 1.298-.416 5.155-.262 1.91 1.459.926 1.904.634.437-.284 1.611-1.093 1.728-1.174.16-.109.044-.197-.08-.379-.088-.124-.175-.036-.175-.036-.474.313-1.342.97-1.459.554-.138-.416.751-3.267 1.24-5.228.08-.467.299-1.488-.547-1.415zm.262-3.478a1.094 1.094 0 100 2.187 1.094 1.094 0 000-2.187z",
    fill: "#2739B1"
  }))));
}

export default SvgInfoItalic;